import { createSlice } from '@reduxjs/toolkit';
import {
  methods,
  payment,
  getAddressFromCoordinates,
  getAddressSuggestions,
} from '~store/shipping/thunks';

export const { actions, reducer } = createSlice({
  name: 'shipping',
  initialState: {
    methods: {},
    selected: {},
    payment: {},
    status: {
      methods: 'idle',
      payment: 'idle',
      addressFromCoordinate: 'idle',
      addressSuggestions: 'idle',
    },
    temporaryAddressPinPoint: null,
    addressFromCoordinate: null,
    addressFromCoordinateFull: null,
    addressSuggestions: null,
    isDragMap: false,
  },
  reducers: {
    select: (state, { payload }) => {
      for (const key in state.methods) {
        state.methods[key].is_selected = payload === key ? true : false;
      }
      state.selected = state.methods[payload];
    },
    status: (state, { payload: { key, value } }) => {
      state.status[key] = value;
    },
    setMapDragging: (state, { payload }) => {
      state.isDragMap = payload;
    },
    setTempAddressPinPoint: (state, { payload }) => {
      state.temporaryAddressPinPoint = payload;
    },
    resetState: (state) => {
      state.methods = {};
      state.selected = {};
      state.payment = {};
    },
    resetStatus: (state) => {
      state.status = status;
    },
    resetAddressSuggestions: (state) => {
      state.addressSuggestions = null;
    },
    resetPinPoint: (state) => {
      state.temporaryAddressPinPoint = null;
      state.addressSuggestions = null;
      state.addressFromCoordinate = null;
      state.addressFromCoordinateFull = null;
      state.status.addressSuggestions = 'idle';
      state.status.addressFromCoordinate = 'idle';
    },
  },
  extraReducers: {
    [methods.rejected]: (state) => {
      state.status.methods = 'failed';
    },
    [methods.pending]: (state) => {
      state.status.methods = 'pending';
    },
    [methods.fulfilled]: (state, { payload }) => {
      if (payload) {
        if (payload?.data?.express_on_delivery) {
          delete payload?.data?.express;
        }
        // initialize
        const sortedData = Object.keys(payload?.data || {})
          .sort((a, b) => (a === 'regular' ? -1 : b === 'regular' ? 1 : 0))
          .reduce((obj, key) => {
            obj[key] = payload.data[key];
            return obj;
          }, {});
        state.methods = sortedData;
        state.selected =
          Object.keys(state.methods)
            .map((item) => state.methods[item])
            .find((item) => item.is_selected) || {};
        state.status.methods = 'succeeded';
      }
    },
    [payment.pending]: (state) => {
      state.status.payment = 'pending';
    },
    [payment.fulfilled]: (state, { payload: { data } }) => {
      state.payment = data;
      state.status.payment = 'succeeded';
    },
    [getAddressFromCoordinates.rejected]: (state) => {
      state.status.addressFromCoordinate = 'failed';
    },
    [getAddressFromCoordinates.pending]: (state) => {
      state.status.addressFromCoordinate = 'pending';
    },
    [getAddressFromCoordinates.fulfilled]: (state, { payload }) => {
      state.addressFromCoordinate = payload.results[0].formatted_address;
      state.addressFromCoordinateFull = payload.results[0];
      state.status.addressFromCoordinate = 'succeeded';
    },
    [getAddressSuggestions.rejected]: (state) => {
      state.status.addressSuggestions = 'failed';
    },
    [getAddressSuggestions.pending]: (state) => {
      state.status.addressSuggestions = 'pending';
    },
    [getAddressSuggestions.fulfilled]: (state, { payload }) => {
      if (
        !payload ||
        !payload.results ||
        !Array.isArray(payload.results) ||
        payload.results.length === 0
      ) {
        state.addressSuggestions = [
          {
            isAddressNotFound: true,
            headMessage: 'Alamat tidak ditemukan',
            bodyMessage: 'Coba kata kunci lain seperti nama jalan atau gedung',
          },
        ];
      } else {
        state.addressSuggestions = payload.results;
      }
      state.status.addressSuggestions = 'succeeded';
    },
  },
});

export default reducer;
